import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Container, Input, Text} from '../components/@FreeModel';
import Header from '../components/general/Header/Header';
import {gql, queryApplication, updateApplicationUpdateContactInfo} from "../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../db/selectors";
import {formatPhoneNumber} from "../utlis/format";
import {pathIncorrectEmail} from "../routes";
import {isCorrectEmail} from "./validate";
import {Mixpanel} from '../observability/Mixpanel'

const ContactInfo = (): React.ReactElement => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (newState) => {
        if (!isCorrectEmail(newState)) {
          navigate(pathIncorrectEmail(applicationID))
          return
        }

        setFirstName(newState.application?.firstName ?? '')
        setLastName(newState.application?.lastName ?? '')
        setPhoneNumber(newState.application?.phoneNumber ?? '')
      }
    }))
  }, [dispatch, applicationID, setFirstName, setLastName, setPhoneNumber]);

  const isValid = firstName !== "" && lastName !== "" && phoneNumber.length === 10;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplicationUpdateContactInfo,
      variables: {
        id: applicationID,
        form: {
          firstName,
          lastName,
          phoneNumber: phoneNumber,
        }
      },
      onSuccess: (_) => {
        Mixpanel.track("contractor-contact-info-added", {
          "invitation": applicationID,
        })
        if (application.hasVerifiedPhoneNumber === true && application.phoneNumber === phoneNumber) {
          navigate(`/contractors/${applicationID}/business-info/1`)
        } else {
          navigate(`/contractors/${applicationID}/contact-info/sms`)
        }
      }
    }))
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Backspace' && (phoneNumber.length === 3 || phoneNumber.length === 6)) {
      setPhoneNumber(phoneNumber.substring(0, phoneNumber.length - 1))
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const phoneNumber = event.target.value.replace(/\D/g, '')
    setPhoneNumber(phoneNumber)
  }
  // 8005551212

  return (
    <Container>
      <Header
        title="Add Contact Info"
        text="Adding your name and mobile phone number will help us keep you updated on projects and any additional
                information."
      />

      <form onSubmit={handleSubmit}>
        <Input
          label="First name"
          id="first-name"
          type="text"
          required
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
        />

        <Input
          label="Last name"
          id="last-name"
          type="text"
          required
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />

        <Input label="Mobile phone number"
               id="phone-number"
               type="tel"
               required
               value={formatPhoneNumber(phoneNumber)}
               onKeyUp={handleKeyUp}
               onChange={handleChange}
        />

        <br/>
        <br/>

        <Text lineHeight="sm" size="sm">
          <strong>NOTE:</strong> We will send you a six-digit code to confirm your phone number.
        </Text>

        <br/>

        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default ContactInfo;
